import { render, staticRenderFns } from "./contractFieldsManager.vue?vue&type=template&id=126d7ba8&scoped=true"
import script from "./contractFieldsManager.vue?vue&type=script&lang=js"
export * from "./contractFieldsManager.vue?vue&type=script&lang=js"
import style0 from "./contractFieldsManager.vue?vue&type=style&index=0&id=126d7ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d7ba8",
  null
  
)

export default component.exports